import { BrandLoaderDots, BrandLoaderHero } from './BrandLoaderHero';
import { BrandStatusPage } from './BrandStatusPage';

export interface GlobalLoaderProps {
  /** Override default copy. */
  message?: string;
}

/**
 * Full-viewport brand loader for auth hydrate and public-route Suspense.
 */
export function GlobalLoader({
  message = 'Getting your clinic ready…',
}: GlobalLoaderProps): JSX.Element {
  return (
    <BrandStatusPage
      layout="viewport"
      tone="brand"
      bareHero
      hero={<BrandLoaderHero />}
      statusPill={
        <div className="mb-4 inline-flex items-center gap-1.5 rounded-full bg-brand-100 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[.16em] text-brand-700">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-brand-500" />
          Loading
        </div>
      }
      title="Loading DentXE"
      description={message}
      detail={
        <div className="mx-auto mb-2 flex justify-center">
          <BrandLoaderDots />
        </div>
      }
      showLogo
    />
  );
}
